import {Component, forwardRef, Input, OnChanges, OnInit,  SimpleChanges} from '@angular/core';
import {ControlValueAccessor, FormArray, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';


@Component({
  selector: 'app-multi-dropdown-import',
  templateUrl: './multi-dropdown-import.component.html',
  styleUrls: ['./multi-dropdown-import.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => MultiDropdownImportComponent),
      multi: true
    }
  ]
})
export class MultiDropdownImportComponent implements OnInit, OnChanges, ControlValueAccessor {

  public checkedList: any[];
  public listText = '';
  public spanText = [];
  public showDropDown: boolean;
  public all: boolean;
  public widthX: any;
  public form: FormGroup;
  @Input() list: any[];
  @Input() id: string;
  @Input() required: boolean;
  @Input() placeholder: string;
  @Input() height: string;
  @Input() width: string;
  public onChange = (_: any) => { };

  constructor(
    private fb: FormBuilder
  ) {
    this.checkedList = [];
    this.createForm();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line:forin
    for (const entry in changes) {
      if (entry === 'list') {
        if (changes['list'].currentValue) {
          this.createForm();
          this.createListData();
        }
      }
      if (entry === 'width') {
       if (changes['width'].currentValue) {
        this.normalizeClass();
       }
      }
    }
  }

  /**
   * @Metodo normalizeClass
   * @description
   * */
  normalizeClass() {
    const a = this.width.substr(-3);
    const x = parseInt(a, 10) - 20;
    this.widthX = 'width-' + x.toString();
  }

  /**
   * @Metodo createForm
   * @description
   * */
  createForm() {
    this.form = this.fb.group({
      listData: this.fb.array([])
    });
    this.form.valueChanges.subscribe(value => {
    });
  }

  /**
   * @Metodo getListData
   * @description
   * */
  getListData(): FormArray {
    return this.form.controls['listData'] as FormArray;
  }

  /**
   * @Metodo createListData
   * @description crea el FormArray ListData
   * */
  createListData() {
    if (this.list.length) {
      this.list.forEach( (val, i) => {
        this.getListData().push(this.fb.group({
          id: [val[this.id], [Validators.required]],
          name: val.description,
          check: [false, [Validators.required]]
        }
        ));
        this.listenDataList(i);
      });
    }
  }

  /**
   * @Metodo listenDataList
   * @description para escuchar los campos del form
   * */
  listenDataList(i) {
    this.getListData().at(i).valueChanges.subscribe(
      val => {this.selectedValue(val); }
      );
  }

  /**
   * @Metodo SelectAll
   * @description Selecciona todos los item
   * */
  SelectAll(checked) {
    this.clear();
    if (checked) {
      this.list.forEach((value, i) => {
        this.getListData().at(i).patchValue({check:  true});
      });
    }
    this.onChange(this.checkedList);
  }

  /**
   * @Metodo selectedValue
   * @description selesciona por cada check
   * */
  selectedValue(val: any): void {
    if (val.check) {
      this.checkedList.push(val.id);
      // this.spanText.push(val.name + ', ');
      this.listText = this.listText + val.name + ', ';
    } else {
      const index = this.checkedList.indexOf(val.id);
      this.checkedList.splice(index, 1 );
      this.listText = this.listText.replace(val.name + ', ', '');
      // this.spanText.splice(index, 1);
    }
    this.onChange(this.checkedList);
  }

  /**
   * this clear selected items
   */
  clear() {
   delete this.checkedList;
    this.spanText = [];
    this.listText = '';
    this.list.forEach((val, i) => {
      this.getListData().at(i).patchValue({check:  false});
    });

  }

  /**
   * @Metodo ControlValueAccessor
   * @description Para el comportamiento del form como campo
   * */
  registerOnChange(fn: any): void {this.onChange = fn; }
  registerOnTouched(fn: any): void {  }
  setDisabledState(isDisabled: boolean): void {  }
  writeValue(obj: any): void {  }

}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/multi-dropdown-import/multi-dropdown-import.component.ts